import React, { useState } from "react";
import Popup from "../../popup/index";
import "./styles/index.scss";
import { states } from "../../common/widgets/formVariablesWidget";
import Button from "../../common/forms/button";
import Delimiter from "../../common/forms/delimiter/Delimiter";
import DKFormTextInput from "../../common/widgets/formVariablesWidget/DKFormTextInput";

const AddAddress = (props) => {
  const {
    errors,
    open,
    onClose,
    companyName,
    onAdd,
    title = "Add Company Address",
  } = props;
  const initialAddress = {
    line: "",
    city: "",
    state: "",
    zip: "",
  };

  const [address, setAddress] = useState(initialAddress);
  const canAdd = address.line && address.city && address.state && address.zip;

  const handleChange = (e) => {
    setAddress({ ...address, [e.target.name]: e.target.value });
  };

  const close = () => {
    onClose();
    setAddress(initialAddress);
  };

  return (
    <Popup isOpen={open} onClosePopup={close}>
      <div className="popup-container">
        <div className="invite-member-popup-container">
          <i className="close-icon" aria-hidden="true" onClick={close} />
          <div className="invite-member-popup-title">{title}</div>
          <div className="investor-company-name">for {companyName}</div>
          <Delimiter type="headline" shift="18" />
          <div className="form-field-container without-padding without-border">
            <DKFormTextInput
              className="deals-input invite-form"
              dataTestId="company-address-street"
              label="Street"
              name="line"
              type="text"
              onChange={handleChange}
              value={address.line || ""}
            />
            {errors && errors.address && errors.address.line && (
              <p className="error">{errors.address.line}</p>
            )}
            <DKFormTextInput
              className="deals-input invite-form"
              dataTestId="company-address-city"
              label="City"
              name="city"
              type="text"
              onChange={handleChange}
              value={address.city || ""}
            />
            {errors && errors.address && errors.address.city && (
              <p className="error">{errors.address.city}</p>
            )}
            <div className="row-fields">
              <div className="deals-input without-margin width-200">
                <DKFormTextInput
                  dataTestId="company-address-state"
                  label="State"
                  name="state"
                  select
                  onChange={handleChange}
                  value={address.state || ""}
                  SelectProps={{
                    native: true,
                  }}
                >
                  {[{ abbreviated: "", name: "" }, ...states].map((option) => {
                    return (
                      <option
                        key={"abbreviation_" + option.abbreviation}
                        value={option.name}
                      >
                        {option.name}
                      </option>
                    );
                  })}
                </DKFormTextInput>
                {errors && errors.address && errors.address.city && (
                  <p className="error">{errors.address.city}</p>
                )}
              </div>
              <div className="deals-input without-margin width-200">
                <DKFormTextInput
                  className="deals-input without-margin"
                  dataTestId="company-address-zip"
                  label="Zip Code"
                  name="zip"
                  type="text"
                  onChange={handleChange}
                  value={address.zip || ""}
                />
                {errors && errors.address && errors.address.zip && (
                  <p className="error">{errors.address.zip}</p>
                )}
              </div>
            </div>
            <Delimiter type="internal" shift="18" />
            <Button
              data-testid="company-address-add-button"
              type={(canAdd && "primary") || "disabled-primary"}
              onClick={() => {
                if (canAdd) {
                  onAdd(address);
                  close();
                }
              }}
            >
              add
            </Button>
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default AddAddress;
